import { getCore } from '../../../client/core/getCore';
import { getDefaultClient } from '../../../client/defaultClient';

/**
 * Allows waiting until all modules of the client have been properly initialized
 * and are ready for use.
 *
 * @returns a promise that resolves once the client is fully initialized.
 */
export const waitForClientInitialized = async (client = getDefaultClient()) => {
  const core = getCore(client);

  await core.initTrack.waitForAll();
};
